import * as React from 'react';
export const grabpaySvg = React.forwardRef(function grabpaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M211.322 32.184c1.028 0 1.77.113 2.387.363l.059.028v.855c-.606-.367-1.36-.531-2.446-.531-1.16 0-2.27.441-3.12 1.238-.813.766-1.29 1.793-1.31 2.828v.317c0 1.125.415 2.168 1.176 2.937a4.04 4.04 0 0 0 2.91 1.2c1.688 0 2.56-.598 2.938-.97l.02-.015.004-.004v-3.11h-3.145v-.765h3.906v4.113l-.035.047c-.094.117-.383.442-.922.766-.785.465-1.715.703-2.765.703a4.804 4.804 0 0 1-3.438-1.422 4.893 4.893 0 0 1-1.414-3.398v-.328c0-2.63 2.379-4.852 5.195-4.852Zm0 1.277c.97 0 1.707.157 2.38.5l.066.035v.907c-.59-.489-1.282-.676-2.446-.676-1.664 0-3.074 1.258-3.105 2.762v.293c0 .761.285 1.472.808 2 .52.523 1.211.812 1.954.812.777 0 1.253-.137 1.527-.238l.148-.059h.008v-1.152h-1.867v-.762h2.582v2.293l-.02.016c-.187.18-.847.664-2.378.664-1.926 0-3.493-1.57-3.524-3.516v-.304c0-.946.406-1.84 1.145-2.52a3.999 3.999 0 0 1 2.722-1.055Zm0 0',
    }),
  );
});
grabpaySvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '8.574',
  height: '10',
  viewBox: '206.127 32.184 8.574 10',
};
export var grabpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'grabpay',
  svg: grabpaySvg,
};
